import type { FetchBaseQueryMeta } from '@reduxjs/toolkit/dist/query/fetchBaseQuery';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import type { BaseQueryApi, QueryReturnValue } from '@reduxjs/toolkit/src/query/baseQueryTypes';
import { setIsAuth } from 'services/redux/auth/slice';

const AUTH_ERROR_CODES = new Set([401]);

export function baseQueryWithReauth(
  baseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>
) {
  return async function (
    args: string | FetchArgs,
    api: BaseQueryApi,
    extraOptions: {}
  ): Promise<QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>> {
    const result = await baseQuery(args, api, extraOptions);

    if (typeof result.error?.status === 'number' && AUTH_ERROR_CODES.has(result.error?.status || 0)) {
      api.dispatch(setIsAuth(false));
    }

    return result;
  };
}
